import { createRequestInterceptor, errorInterceptor, getSipApiUrl } from "@/lib/apiConfig";
import { attachAuthRefreshInterceptor } from "@/lib/authSession";
import axios from "axios";

/** sip.io-v2 /v1, telephony (NEXT_PUBLIC_SIP_API_URL, already ending in /v1; :8794 locally). Same
 *  wiring as pbxClient — see there. */
export const sipClient = axios.create();
sipClient.interceptors.request.use(createRequestInterceptor(getSipApiUrl));
attachAuthRefreshInterceptor(sipClient);
sipClient.interceptors.response.use(undefined, errorInterceptor);
